import React from 'react';
import PropTypes from 'prop-types';
import numeral from 'numeral';
import { makeStyles } from '@material-ui/core';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import { handleCellColor } from 'utils/widget-helpers';

const useStyles = makeStyles(theme => ({
  container: {
    margin: '0 auto'
  },
  name: {
    textAlign: 'center',
    fontSize: '13px',
    marginTop: '8px',
    fontWeight: '600'
  },
  value: {
    fontSize: '24px',
    fontWeight: '600'
  },
  compactName: {
    fontSize: theme.customStyles.tableRow.fontSize,
    padding: theme.customStyles.tableRow.padding,
    marginTop: '8px',
    textAlign: 'center'
  },
  compactValue: {
    fontSize: '14px',
    fontWeight: '500'
  },
  spanRows: {
    minHeight: '55px',
    maxHeight: '60px'
  }
}));

const PerformanceCell = ({ text, value }) => {
  const classes = useStyles();

  const cellColor = handleCellColor(value);

  return (
    <Box bgcolor="#F9F9F9" height="100%" width="100%" p={2} mt={1}>
      <Box
        border={`2px solid ${cellColor}`}
        height="90px"
        width="90px"
        display="flex"
        borderRadius="50%"
        alignItems="center"
        justifyContent="center"
        className={classes.container}
      >
        {value ? (
          <Typography className={classes.compactValue} style={{ color: `${cellColor}` }}>
            {value > 0 && '+'}
            {numeral(value).format('0.00%')}
          </Typography>
        ) : (
          <Typography className={classes.compactValue} style={{ color: `${cellColor}` }}>
            N.A.
          </Typography>
        )}
      </Box>
      <Box className={classes.spanRows}>
        <Typography className={classes.compactName}>{text}</Typography>
      </Box>
    </Box>
  );
};

PerformanceCell.propTypes = {
  text: PropTypes.string,
  value: PropTypes.number
};

PerformanceCell.defaultProps = {
  text: null,
  value: null
};

export default PerformanceCell;
